import { t } from "@lingui/core/macro";
import { clsx } from "@regrello/core-utils";
import React from "react";

export interface RegrelloRequiredAsteriskProps {
  /** Whether the asterisk should be muted. */
  isMuted?: boolean;
}

/** Renders a consistent red asterisk to use whenever denoting that something is required. */
export const RegrelloRequiredAsterisk = React.memo<RegrelloRequiredAsteriskProps>(function RegrelloRequiredAsteriskFn({
  isMuted,
}: RegrelloRequiredAsteriskProps) {
  return (
    <span className={clsx("text-danger-icon", { "text-danger-iconMuted": isMuted })} title={t`Required`}>
      *
    </span>
  );
});
